module.exports = __webpack_public_path__ + "static/media/icon-marker-darkmagenta.88739104.svg";